export default __webpack_public_path__ + "media/img/primary-left-58f0abdf1a40a975c669322621df0c46.svg";